import { borderRadius, Card, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { Layout } from '../auth-shared-styles/AuthSharedStyles.styles';

export const Wrapper = styled(Layout)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 48px;
`;

export const StyledCard = styled(Card)`
  text-align: center;
  width: 544px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px 40px 40px;
  ${borderRadius.r2}
`;

export const Title = styled.h1`
  ${typographyV2.titleXL}
`;

export const Description = styled.p`
  ${typographyV2.bodyBase}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 20px 0;
`;

export const LockIcon = styled.img`
  width: 80px;
  height: 100px;
  margin-top: -40px;
`;

export const Contact = styled.div`
  ${typographyV2.bodySm}
  margin-top: 20px;
  display: flex;
  justify-content: center;
  a {
    margin-left: 5px;
    color: var(--text-primary);
  }
`;

export const ButtonWrapper = styled.div`
  margin-bottom: 8px;
`;
